"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToSlug = void 0;
const convertToSlug = (text) => {
    if (typeof text !== "string")
        return "";
    return text
        .toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-");
};
exports.convertToSlug = convertToSlug;
